// This file is autogenerated. DO NOT MODIFY

export const EORA_EFFECTS = {
  EFFECTS: {
    STYLE: {
      BACKGROUND_BLUR: {
        SM: 'blur(8px)',
        MD: 'blur(16px)',
        LG: 'blur(24px)',
        XL: 'blur(40px)'
      },
      SHADOW: {
        SHADOW_LIGHT: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)',
        SHADOW_DEFAULT: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px 3px 5px 0px rgba(9, 30, 66, 0.2)',
        SHADOW_BOLD: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px 8px 12px 0px rgba(9, 30, 66, 0.15)',
        SHADOW_STRONG: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px 10px 18px 0px rgba(9, 30, 66, 0.15)',
        SHADOW_XSTRONG: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px 18px 28px 0px rgba(9, 30, 66, 0.15)',
        SHADOW_INVERTED: '0px 0px 1px 0px rgba(9, 30, 66, 0.3), 0px -8px 12px 0px rgba(9, 30, 66, 0.15), 0px 4px 4px 0px rgba(255, 255, 255, 1)'
      },
      FOCUS_RING: {
        FOCUS_RING: '0px 0px 0px 2px rgba(0, 112, 240, 0.5)',
        FOCUS_RING_ERROR: '0px 0px 0px 2px rgba(234, 27, 12, 0.5)'
      },
      Z_IGNORE: { XS_IGNORE: '0px 4px 4px 0px rgba(0, 0, 0, 0.3)' }
    }
  }
} as const;

export type EoraEffects = typeof EORA_EFFECTS;
export type EoraEffect = EoraEffects[keyof EoraEffects];
